/**
 * The BFF's `ApiError.details` is documented as `additionalProperties: { type: string }` — a flat
 * string-keyed map (e.g. `ATTRIBUTE_VALIDATION_FAILED` → `{attribute, rule, expected}`, the
 * category delete-guard 409 → `{childCategories, products}`). `NormalizedApiError.details` types
 * this as `unknown` at the transport boundary, so every call site narrows it the same way — this
 * is that one shared narrowing helper (previously duplicated ad hoc, e.g. `CategoriesPage`'s
 * `readDeleteConflictCounts`).
 */
export function readStringDetails(details: unknown): Record<string, string> | undefined {
  if (!details || typeof details !== 'object') return undefined;
  const record = details as Record<string, unknown>;
  const out: Record<string, string> = {};
  let any = false;
  for (const [key, value] of Object.entries(record)) {
    if (typeof value === 'string') {
      out[key] = value;
      any = true;
    }
  }
  return any ? out : undefined;
}
